"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var useModalStyles = function useModalStyles() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      showTitle: false
    },
    _ref$showTitle = _ref.showTitle,
    showTitle = _ref$showTitle === void 0 ? false : _ref$showTitle;
  return (0, _styles.makeStyles)(function (theme) {
    return (0, _styles.createStyles)({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& [role=document]': {
          width: '100%'
        },
        '& [role=document]:focus': {
          outline: 'none'
        }
      },
      animatedDiv: {
        '&:focus': {
          outline: 'none'
        }
      },
      widthSmall: {
        width: 400
      },
      widthMedium: {
        width: 600
      },
      widthLarge: {
        width: 800
      },
      widthXLarge: {
        width: 968
      },
      headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 0,
        marginBottom: showTitle ? 24 : 0
      },
      paper: _defineProperty({
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
        boxShadow: theme.shadows[2],
        padding: theme.spacing(3, 3, 2),
        margin: '0 auto',
        maxHeight: '100vh',
        overflowY: 'auto'
      }, theme.breakpoints.down('xs'), {
        maxWidth: '93%'
      }),
      title: {
        margin: 0,
        fontFamily: theme.typography.fontFamily,
        fontStyle: 'normal',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(24)
      },
      footerModal: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 10
      },
      buttonPrimary: {
        color: theme.palette.BLUE400
      },
      buttontextPrimary: {
        '&:hover': {
          backgroundColor: theme.palette.BLUE050
        }
      },
      closeIcon: {
        height: theme.typography.pxToRem(44),
        width: theme.typography.pxToRem(44),
        marginLeft: theme.spacing(2),
        marginTop: theme.typography.pxToRem(-11),
        marginRight: theme.typography.pxToRem(-11)
      }
    });
  })();
};
var _default = useModalStyles;
exports.default = _default;